import { render, staticRenderFns } from "./BeneficiarieUpdateRequests.vue?vue&type=template&id=f0ada26a&"
import script from "./BeneficiarieUpdateRequests.vue?vue&type=script&lang=js&"
export * from "./BeneficiarieUpdateRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports